export const TYPE_SET_PRODUCT_DETAILS = "setProductDetails";
export const TYPE_SET_CATEGORY_TOGGLE = "setToggle";
export const TYPE_SET_STEP = "setStep";
export const TYPE_SET_SUBSTEP = "setSubstep";
export const TYPE_SET_SUMMARY_STEP = "setSummaryStep";
export const TYPE_SET_BOTTOM_TOOLBAR_EXPANDED = "setBottomToolbarExpanded";
export const TYPE_SET_GIFT_BOXES = "setGiftBoxes";
export const TYPE_SET_GIFTS = "setGifts";
export const TYPE_SET_ADDONS = "setAddOns";
export const TYPE_SET_GIFT_CARDS = "setGiftCards";
export const TYPE_SET_CATEGORIES = "setCategories";
export const TYPE_SET_CURRENT_CATEGORY = "setCurrentCategory";
export const TYPE_ADD_TO_BOX = "addToBox";
export const TYPE_REMOVE_FROM_BOX = "removeFromBox";
export const TYPE_SET_ITEM_AMOUNT = "setItemAmount";
export const TYPE_SET_CARD_MESSAGE = "setCardMessage";
export const TYPE_SET_CARD_SIGNOFF = "setCardSignoff";
export const TYPE_SET_BOX_SETTINGS = 'setBoxSettings';
export const TYPE_SWAP_BOX_ITEMS = 'swapBoxItems';
export const TYPE_SET_PRODUCT_DIALOG_TOGGLE = 'setProductDialogToggle';
export const TYPE_SET_PRODUCT_DIALOG_ITEM = 'setProductDialogItem';
export const TYPE_SET_PRODUCT_AMOUNT = 'setProductAmount';
export const TYPE_SET_SCREEN = 'setScreen';
export const TYPE_SET_REPLACE_ITEM = 'setReplaceItem';
export const TYPE_SET_NEXT_TO_SUMMARY = 'setNextToSummary';
export const TYPE_SET_DELIVERY_AREA = 'setDeliveryArea';
export const TYPE_SET_DELIVERY = 'setDeliveryDetails';
export const TYPE_SET_DELIVERY_DATE = 'setDeliveryDate';
export const TYPE_SET_ERROR = 'setError';
export const TYPE_SET_ERROR_TOGGLE = 'setShowError';
export const TYPE_SET_RECIPIENT_TYPE = 'setRecipientType';
export const TYPE_SET_SELECTED_ADDR_INDEX = 'setSelectedAddrIndex';
export const TYPE_SET_SELECTED_PRICE_RANGE = 'setSelectedPriceRange';
export const TYPE_SET_CUSTOMER_HASH = 'setCustomerHash';
export const TYPE_SET_CUSTOMER_ID = 'setCustomerId';
export const TYPE_SET_ADD_TO_FAVOURITE = 'setAddToFavourite';
export const TYPE_SET_SELECTED_CARD_INDEX = 'setSelectedGiftCard';
export const TYPE_SET_TIMESLOTS = 'setTimeslots';

const mutations = {
    [TYPE_SET_TIMESLOTS](state,timeslots){
        state.timeslots = timeslots;
    },
    [TYPE_SET_CUSTOMER_HASH](state, hash){
        state.customerHash = hash;
    },
    [TYPE_SET_CUSTOMER_ID](state, id){
        state.customerId = id;
    },
    [TYPE_SET_PRODUCT_DETAILS](state, details){
        state.productDetails = details;
    },
    [TYPE_SET_CATEGORY_TOGGLE](state, toggle){
        state.categoryToggle = toggle;
    },
    //refactor needed
    [TYPE_SET_STEP](state, step){
        document.querySelector('#hb-bab-stepper').scrollIntoView();
        state.step = step;
    },
    [TYPE_SET_SUBSTEP](state, substep){
        if(document.querySelector('#hb-bab-stepper'))
            document.querySelector('#hb-bab-stepper').scrollIntoView();
        state.substep = substep;
    },
    [TYPE_SET_SUMMARY_STEP](state, step){
        if(document.querySelector('#hb-bab-stepper'))
            document.querySelector('#hb-bab-stepper').scrollIntoView();
        state.summaryStep = step;
    },
    [TYPE_SET_BOTTOM_TOOLBAR_EXPANDED](state, bottomToolbar){
        state.bottomToolbarExpanded = bottomToolbar;
    },
    [TYPE_SET_GIFT_BOXES](state, giftBoxes){
        state.giftBoxes = giftBoxes;
    },
    [TYPE_SET_GIFTS](state, gifts){
        state.gifts = gifts;
    },
    [TYPE_SET_CATEGORIES](state, categories){
        state.categories = categories;
    },
    [TYPE_SET_ADDONS](state, addons){
        state.addons = addons;
    },
    [TYPE_SET_GIFT_CARDS](state, giftCards){
        state.giftCards = giftCards;
    },
    [TYPE_SET_CURRENT_CATEGORY](state, category){
        state.currentCategory = category;
    },
    [TYPE_ADD_TO_BOX](state, product){
        state.box.push(product);
    },
    [TYPE_REMOVE_FROM_BOX](state, itemIndex){
        state.box.splice(itemIndex, 1);
    },
    [TYPE_SET_ITEM_AMOUNT](state, {amount, itemIndex}){
        const clone = JSON.parse(JSON.stringify(state.box[itemIndex]));
        clone.amount = amount;
        state.box.splice(itemIndex, 1, clone);
    },
    [TYPE_SET_CARD_MESSAGE](state, message){
        state.cardMessage = message;
    },
    [TYPE_SET_CARD_SIGNOFF](state, signoff){
        state.signoff = signoff;
    },
    [TYPE_SET_BOX_SETTINGS](state, settings){
        state.boxSettings = settings;
    },
    [TYPE_SWAP_BOX_ITEMS](state, {newItem, itemIndex}){
        if(!newItem.amount)
            newItem.amount = state.box[itemIndex].amount;
        state.box.splice(itemIndex, 1, newItem);
    },
    [TYPE_SET_PRODUCT_DIALOG_TOGGLE](state, toggle){
        state.productDialogToggle = toggle;
    },
    [TYPE_SET_PRODUCT_DIALOG_ITEM](state, item){
        state.productDialogItem = item;
    },
    [TYPE_SET_PRODUCT_AMOUNT](state, amount){
        state.productAmount = amount;
    },
    [TYPE_SET_SCREEN](state, screen){
        state.screen = screen;
    },
    [TYPE_SET_REPLACE_ITEM](state, item){
        state.replaceable = item;
    },
    [TYPE_SET_NEXT_TO_SUMMARY](state, nextToSummary){
        state.nextToSummary = nextToSummary;
    },
    [TYPE_SET_DELIVERY_AREA](state, deliveryArea){
        state.deliveryArea = deliveryArea;
    },
    [TYPE_SET_DELIVERY](state, delivery){
        state.delivery = delivery;
    },
    [TYPE_SET_DELIVERY_DATE](state, date){
        state.delivery.delivery_date = date;
    },
    [TYPE_SET_ERROR](state, message){
        state.errorMessage = message;
        state.showError = true;
    },
    [TYPE_SET_ERROR_TOGGLE](state, toggle){
        state.showError = toggle;
    },
    [TYPE_SET_RECIPIENT_TYPE](state, type){
        state.recipientType = type;
    },
    [TYPE_SET_SELECTED_ADDR_INDEX](state, addrIndex){
        state.selectedAddrIndex = addrIndex;
    },
    [TYPE_SET_SELECTED_PRICE_RANGE](state, priceRange){
        state.selectedPriceRange = priceRange;
    },
    [TYPE_SET_ADD_TO_FAVOURITE](state, addToFavourite){
        state.addToFavourite = addToFavourite;
    },
    [TYPE_SET_SELECTED_CARD_INDEX](state, card){
        state.selectedCardIndex = card;
    }
}

export default mutations;